export type GrossActivityThresholds = {
  low: number;
  high: number;
};

export type GrossActivityInputRow = {
  openInterest: number;
  DealerLong: number;
  DealerShort: number;
  DealerSpread?: number;
  AssetManagerLong: number;
  AssetManagerShort: number;
  AssetManagerSpread?: number;
  LeveragedMoneyLong: number;
  LeveragedMoneyShort: number;
  LeveragedMoneySpread?: number;
};

export const computeGrossPctOI = (row: GrossActivityInputRow) => {
  if (!row || !row.openInterest) {
    return {
      dealer: null,
      assetManager: null,
      leveragedMoney: null,
    };
  }
  const openInterest = row.openInterest;
  const compute = (longValue: number, shortValue: number, spreadValue?: number) => {
    const gross = (longValue || 0) + (shortValue || 0) + (spreadValue || 0);
    return (gross / openInterest) * 100;
  };
  return {
    dealer: compute(row.DealerLong, row.DealerShort, row.DealerSpread),
    assetManager: compute(row.AssetManagerLong, row.AssetManagerShort, row.AssetManagerSpread),
    leveragedMoney: compute(row.LeveragedMoneyLong, row.LeveragedMoneyShort, row.LeveragedMoneySpread),
  };
};

export const computeGrossCombinedPctOI = (row: GrossActivityInputRow) => {
  const gross = computeGrossPctOI(row);
  const values = [gross.dealer, gross.assetManager, gross.leveragedMoney].filter(
    (value) => typeof value === 'number' && Number.isFinite(value)
  ) as number[];
  if (!values.length) {
    return null;
  }
  return values.reduce((sum, value) => sum + value, 0);
};

export const computePercentile = (series: number[], value: number) => {
  if (!Number.isFinite(value)) {
    return 0;
  }
  const clean = series.filter((item) => typeof item === 'number' && Number.isFinite(item));
  if (!clean.length) {
    return 0;
  }
  const sorted = [...clean].sort((a, b) => a - b);
  const count = sorted.filter((item) => item <= value).length;
  return (count / sorted.length) * 100;
};

export const classifyGrossActivity = (percentile: number, thresholds: GrossActivityThresholds) => {
  if (percentile <= thresholds.low) {
    return 'Low';
  }
  if (percentile <= thresholds.high) {
    return 'Normal';
  }
  return 'Elevated';
};
